import { Dispatch, SetStateAction, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { Modal, Button, TextField } from "@mui/material";

interface ModalProps {
    open: boolean;
    onClose: () => void;
    setOpen: Dispatch<SetStateAction<boolean>>;
    onAdd?: (tagName: string) => void;
}

export default function AddTags({ open, onClose, setOpen, onAdd }: ModalProps) {
    const [tagName, setTagName] = useState("");
    const [error, setError] = useState(false);

    const handleSubmit = () => {
        if (!tagName.trim()) {
            setError(true);
            return;
        }
        if (onAdd) onAdd(tagName.trim());
        setTagName("");
        setError(false);
        setOpen(false);
    };

    const handleClose = () => {
        setTagName("");
        setError(false);
        setOpen(false);
    };

    return (
        <Modal className="modal addNotification_modal" open={open} onClose={handleClose}>
            <div className="modal-dialog">
                <div className="modal-body">
                    <div className="modal_title">
                        <h2>Add Tag</h2>
                        <button type="button" className="btn-close" onClick={handleClose}>
                            <CloseIcon />
                        </button>
                    </div>
                    <form className="form" onSubmit={(e) => { e.preventDefault(); handleSubmit(); }}>
                        <div className="control_group">
                            <label htmlFor="tag-name">
                                Tag Name <span className="required">*</span>
                            </label>
                            <TextField
                                id="tag-name"
                                placeholder="e.g. Trending, Reels, Products"
                                fullWidth
                                value={tagName}
                                onChange={(e) => {
                                    setTagName(e.target.value);
                                    if (error) setError(false);
                                }}
                                error={error}
                                helperText={error ? "Tag name is required" : ""}
                            />
                        </div>
                        <div className="footer_btn_flex">
                            <Button className="btn btn_grey" onClick={handleClose}>
                                Cancel
                            </Button>
                            <Button className="btn btn_primary" onClick={handleSubmit}>
                                Add Tag
                            </Button>
                        </div>
                    </form>
                </div>
            </div>
        </Modal>
    );
}
